import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "@/auth/AuthContext";
import { PortalShell } from "@/components/PortalShell";
import { EnrollPage } from "@/pages/EnrollPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { TenantsPage } from "@/pages/TenantsPage";
import { TenantDetailPage } from "@/pages/TenantDetailPage";
import { InvoicesPage } from "@/pages/InvoicesPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { BillingPage } from "@/pages/BillingPage";
import { ResellersPage } from "@/pages/ResellersPage";
import { ApiKeysPage } from "@/pages/ApiKeysPage";
import { MailConfigPage } from "@/pages/MailConfigPage";

function ProtectedShell() {
    return (
        <ProtectedRoute>
            <PortalShell />
        </ProtectedRoute>
    );
}

export function App() {
    return (
        <Routes>
            <Route path="/enroll" element={<EnrollPage />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route element={<ProtectedShell />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/tenants" element={<TenantsPage />} />
                <Route path="/tenants/:id" element={<TenantDetailPage />} />
                <Route path="/invoices" element={<InvoicesPage />} />
                <Route path="/billing" element={<BillingPage />} />
                <Route path="/resellers" element={<ResellersPage />} />
                <Route path="/api-keys" element={<ApiKeysPage />} />
                <Route path="/mail-config" element={<MailConfigPage />} />
                <Route path="/settings" element={<SettingsPage />} />
            </Route>
        </Routes>
    );
}
